/**
 * Resolución de URLs de archivos estáticos servidos por el backend (/uploads/...).
 *
 * Antes se hacía `API_URL.replace('/api/', '')`, que es incorrecto: con
 * REACT_APP_API = "http://localhost:3000/api/v1/" el resultado era
 * "http://localhost:3000v1/" — una URL inválida, de ahí los íconos de imagen rota.
 *
 * Lo que se necesita es el *origen* del backend, no un recorte de cadena.
 */

/** Origen del backend, p. ej. "http://localhost:3000" (sin ruta ni /api/v1). */
export const BACKEND_ORIGIN: string = (() => {
  const api = process.env.REACT_APP_API || '';
  try {
    // El segundo argumento permite que REACT_APP_API sea relativo (ej. "/api/v1/").
    return new URL(api, window.location.origin).origin;
  } catch {
    return window.location.origin;
  }
})();

/**
 * Convierte un path relativo del backend (ej. "/uploads/faces/abc.jpg") en una URL
 * absoluta apta para <img src>. Deja intactas las URLs que ya son absolutas
 * (http/https), los data: y los blob: generados por URL.createObjectURL.
 */
export function backendFileUrl(p?: string | null): string {
  if (!p) return '';
  if (/^(https?:)?\/\//i.test(p) || p.startsWith('data:') || p.startsWith('blob:')) return p;
  return `${BACKEND_ORIGIN}${p.startsWith('/') ? '' : '/'}${p}`;
}
